module.exports = __webpack_public_path__ + "img/urinal.a3669a9b.svg";